// extracted by mini-css-extract-plugin
export var Interface_Medium_M = "typography-module--Interface_Medium_M--2989f";
export var Neutral_4 = "#8F8F8F";
export var colors = "\"@theme/colors.module.css\"";
export var style_component = "FormLayout-module--style_component--958c7 typography-module--typeface_base--8d193 typography-module--Interface_Medium_M--2989f";
export var style_content = "FormLayout-module--style_content--ba627";
export var typeface_base = "typography-module--typeface_base--8d193";
export var typography = "\"@theme/typography.module.css\"";